import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { SEQUENCES_CUSTOM_FIELDS_KEY } from './useSequenceCustomFieldDefinitions';

function deleteSequenceCustomField(id: string) {
  return request(`/sequences-custom-fields/${id}`, {
    method: 'DELETE',
  });
}

export const useDeleteSequenceCustomFieldDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSequenceCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
